"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _DisabledButton = _interopRequireDefault(require("./DisabledButton"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var PrimaryButton = (0, _styledComponents["default"])(_DisabledButton["default"]).attrs(function () {
  return {
    className: "btn btn-primary",
    name: "primary-button"
  };
}).withConfig({
  displayName: "PrimaryButton",
  componentId: "f9a864-0"
})([""]);
var _default = PrimaryButton;
exports["default"] = _default;